import axios from "axios";
import { toast } from "sonner";

export async function downloadExcel(url, fallbackName) {
  try {
    const res = await axios.get(url, { responseType: "blob" });
    const match = /filename="?([^"]+)"?/.exec(res.headers["content-disposition"] || "");
    const name = match ? match[1] : fallbackName;
    const href = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
    toast.success(`Downloaded ${name}`);
  } catch (e) {
    toast.error("Export failed");
  }
}
